﻿import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TextValidator, ValidatorComponentProps } from 'react-material-ui-form-validator';

const green = '#5ec4b6';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& .MuiInput-root': {
                color: '#867874',
                backgroundColor: '#fefefe',
                minHeight: '3.125rem',
                padding: '0.5rem',
                boxShadow: 'inset 0 1px 2px rgb(10 10 10 / 10%)',
            },
            '& .MuiInput-underline:before': {
                borderBottomColor: green,
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottomColor: green,
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: green,
            },
        },
    })
);

export default function GreenTextValidator(props: ValidatorComponentProps) {
    const classes = useStyles();

    return (
        <TextValidator className={classes.root} {...props} />
    );
}